import {
    getAsync,
    postAsync,
    putAsync,
    deleteAsync
} from "../helpers/apiHelper";

const endpoint = process.env.VUE_APP_BACKEND + "/api/Skill";

// Get all Skill for a discipline
export async function getSkillsForDisciplineAsync(disciplineId) {
  return await getAsync(`${endpoint}/getAllForDiscipline/${disciplineId}`);
}

// Get all Skill for an Exercise as Tree
export async function getSkillsForExerciseAsTreeAsync(exerciseId) {
  return await getAsync(`${endpoint}/getSelectedForExerciseAsTree/${exerciseId}`);
}

// Create an Skill for a Discipline
export async function createSkillForDisciplineAsync(disciplineId, model) {
  return await postAsync(`${endpoint}/${disciplineId}`, model);
}

// Update an Skill
export async function updateSkillAsync(model) {
  return await putAsync(`${endpoint}/${model.id}`, model);
}

// Delete an Skill
export async function deleteSkillAsync(Id) {
  return await deleteAsync(`${endpoint}/${Id}`);
}